import { StyledCheckbox } from './style'
import { Icon } from '../icon';

const Checkbox = ({ checked, onChange, text, style }) => {
  return(
    <StyledCheckbox className={`checkbox ${style}`}>
      <div className="checkbox-input">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
        />

        <Icon icon="check" />
      </div>

      {text && <div className="checkbox-text">{text}</div>}
    </StyledCheckbox>
  )
}

export default Checkbox
